import { getFlags } from '../services/featureFlagsService';

export function hasPermission(user, permission) {
  if (!user) return false;
  const role = user.role || 'viewer';
  if (role === 'admin') return true; // admin always has everything
  const flags = getFlags();
  return (flags[role] || []).includes(permission);
}

export const canViewContacts      = user => hasPermission(user, 'contacts.view');
export const canEditContacts      = user => hasPermission(user, 'contacts.edit');
export const canDeleteContacts    = user => hasPermission(user, 'contacts.delete');
export const canImportContacts    = user => hasPermission(user, 'contacts.import');
export const canExportContacts    = user => hasPermission(user, 'contacts.export');
export const canViewAnalytics     = user => hasPermission(user, 'analytics.view');
export const canManageUsers       = user => hasPermission(user, 'users.manage');
export const canManageSettings    = user => hasPermission(user, 'settings.manage');
export const canManageAutomations = user => hasPermission(user, 'automations.manage');
export const canViewPipeline      = user => hasPermission(user, 'pipeline.view');
export const canEditPipeline      = user => hasPermission(user, 'pipeline.edit');
export const canViewTrash         = user => hasPermission(user, 'trash.view');
export const canRestoreTrash      = user => hasPermission(user, 'trash.restore');
